/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  TextField
} from '@material-ui/core';
import isFunction from 'lodash.isfunction';
// import isURL from 'is-url';
import NumberFormat from 'react-number-format';

import api from '../../../api';
import LoadingIndicator from '../../../components/LoadingIndicator';
import localstring from '../../../services/Localization';
import { API_ROOT } from '../../../constants';
import isValidEmail from '../../../utils/is-valid-email';
import isValidPhone from '../../../utils/is-valid-phone';
import phoneFormatter from '../../../utils/phone-formatter';

function NumberFormatCustom(props) {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={values => {
        onChange({
          target: {
            value: values.value
          }
        });
      }}
      format="###-###-####"
      mask="_"
    />
  );
}

class ContactUs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isError: false,
      isSending: false,
      isSuccess: false,
      isValidForm: false,
      showStatusModal: false,

      brokerageName: '',
      brokerageSite: '',
      email: '',
      numAgents: 9,
      phone: '',
      yourName: ''
    };
    this._delay = null;
    this._isMounted = false;
  }

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    if (this._delay) {
      clearTimeout(this._delay);
      this._delay = null;
    }
    this._isMounted = false;
  }

  submit = async () => {
    this.setState({
      showStatusModal: true,
      isSending: true
    });
    try {
      const response = await api.post(`${API_ROOT}/user/contact`, {
        siteForm: 'AdminSite',
        subject: 'Help with My Account',
        message: this.createMessage()
      });
      if (response.status === 200 && this._isMounted) {
        this.setState(
          {
            isSending: false,
            isSuccess: true
          },
          () => {
            if (isFunction(this.props.onSubmit)) {
              this.props.onSubmit();
              return null;
            }
            if (isFunction(this.props.onClose)) {
              this.props.onClose();
            }
            return null;
          }
        );
      }
    } catch (ex) {
      // const msg = ex.response ? ex.response.data.msg : ex.msg;
      this._isMounted &&
        this.setState(
          {
            isSending: false,
            isError: true
          },
          () => {
            if (isFunction(this.props.onClose)) {
              this.props.onClose();
            }
          }
        );
    }
  };

  isValidForm = () =>
    isValidEmail(this.state.email) &&
    isValidPhone(this.state.phone) &&
    this.state.yourName !== '' &&
    this.state.brokerageName !== '';

  createMessage = () => {
    const openingLine = 'Prospective client email:\n';
    const brokerageNameLine = `Brokerage Name: ${this.state.brokerageName}\n`;
    const brokerageSiteLine = `Brokerage Site: ${this.state.brokerageSite}\n`;
    const agentsLine = `Number of Agents: ${this.state.numAgents}\n`;
    const contactNameLine = `Contact Name: ${this.state.yourName}\n`;
    const contactPhoneLine = `Contact Phone: ${phoneFormatter(
      this.state.phone
    )}\n`;
    const contactEmailLine = `Contact Email: ${this.state.email}\n`;
    return (
      openingLine +
      contactNameLine +
      contactPhoneLine +
      contactEmailLine +
      brokerageNameLine +
      brokerageSiteLine +
      agentsLine
    );
  };

  handleChange = name => e => {
    this.setState(
      {
        [name]: e.target.value
      },
      () => {
        this.setState({
          isValidForm: this.isValidForm()
        });
      }
    );
  };

  selectCancelButton = () => {
    if (isFunction(this.props.onClose)) {
      this.props.onClose();
    }
  };

  close = () => {
    this.setState(
      {
        showStatusModal: false
      },
      () => {
        this._delay = setTimeout(() => {
          this.setState({
            isError: false,
            isSuccess: false,
            isValidForm: false,
            brokerageName: '',
            brokerageSite: '',
            email: '',
            numAgents: 9,
            phone: '',
            yourName: ''
          });
        }, 500);
      }
    );
  };

  renderStatusDialogContent = () => {
    const { isError, isSuccess } = this.state;
    return (
      <>
        {isError && <DialogTitle>Error sending your email.</DialogTitle>}
        {isSuccess && <DialogTitle>Success! Your email was sent.</DialogTitle>}
        <DialogContent className="realm--modal-content">
          {isSuccess && (
            <div>
              Thank you for your message. Please expect a response from a REALM
              representative within 1-2 business days.
            </div>
          )}
          {isError && (
            <div>
              Your email could not be sent at this time. Please either try again
              or contact a REALM representative directly at{' '}
              <a
                style={{ textDecoration: 'underline' }}
                href="mailto:concierge@realm-global.com"
              >
                concierge@realm-global.com
              </a>{' '}
              for further assistance. We apologize for the inconvenience.
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={this.close} color="primary" variant="contained">
            {localstring.onboarding.ok}
          </Button>
        </DialogActions>
      </>
    );
  };

  render() {
    return (
      <>
        <Dialog
          aria-describedby="contact-us-dialog"
          aria-labelledby="contact-us-dialog-title"
          onClose={this.handleClose}
          open={this.props.open}
          fullWidth
          size="small"
        >
          <DialogTitle
            style={{ paddingBottom: 0 }}
            id="contact-us-dialog-title"
          >
            {localstring.contact_us_title}
          </DialogTitle>
          <div className="realm--modal-content" style={{ paddingTop: 0 }}>
            <p>
              REALM would like to assist you to learn more about the REALM Mega
              Team membership plan. Please provide the following information and
              our concierge will set up a time to discuss the pricing and
              benefits.
            </p>
            <div style={{ marginBottom: 20 }}>
              <TextField
                id="yourName"
                fullWidth
                helperText=""
                label={localstring.your_name}
                margin="dense"
                name="yourName"
                onChange={this.handleChange('yourName')}
                required
                type="text"
                value={this.state.yourName}
              />
            </div>
            <div style={{ marginBottom: 20 }}>
              <TextField
                id="phone"
                fullWidth
                helperText=""
                label={`${localstring.phone_number} *`}
                name="phone"
                onChange={this.handleChange('phone')}
                type="text"
                value={this.state.phone}
                InputProps={{
                  inputComponent: NumberFormatCustom
                }}
              />
            </div>
            <div style={{ marginBottom: 20 }}>
              <TextField
                id="email"
                fullWidth
                helperText=""
                label={localstring.email_address}
                margin="dense"
                name="email"
                onChange={this.handleChange('email')}
                required
                type="text"
                value={this.state.email}
              />
            </div>
            <div style={{ marginBottom: 20 }}>
              <TextField
                id="brokerageName"
                fullWidth
                helperText=""
                label={localstring.brokerage_name}
                margin="dense"
                name="brokerageName"
                onChange={this.handleChange('brokerageName')}
                required
                type="text"
                value={this.state.brokerageName}
              />
            </div>
            <div style={{ marginBottom: 15 }}>
              <TextField
                id="numAgents"
                fullWidth
                helperText=""
                label={localstring.num_agents}
                margin="dense"
                name="numAgents"
                onChange={this.handleChange('numAgents')}
                type="number"
                value={this.state.numAgents}
              />
            </div>
            <div style={{ marginBottom: 15 }}>
              <TextField
                id="brokerageSite"
                fullWidth
                helperText=""
                label={localstring.brokerage_site}
                margin="dense"
                name="brokerageSite"
                onChange={this.handleChange('brokerageSite')}
                type="text"
                value={this.state.brokerageSite}
              />
            </div>
          </div>
          <DialogActions>
            <Button
              onClick={this.selectCancelButton}
              color="default"
              variant="contained"
            >
              {localstring.cancel}
            </Button>
            <Button
              onClick={this.submit}
              color="primary"
              variant="contained"
              disabled={!this.state.isValidForm}
            >
              {localstring.contact_send}
            </Button>
          </DialogActions>
        </Dialog>

        {/* email status dialog */}
        <Dialog
          disableBackdropClick
          disableEscapeKeyDown
          maxWidth="md"
          open={this.state.showStatusModal}
        >
          {this.state.isSending && (
            <div
              className="realm--modal-content"
              style={{ position: 'relative' }}
            >
              <div style={{ width: '100%', textAlign: 'center' }}>
                <p style={{ color: '#fff' }}>Sending email ...</p>
                <div style={{ width: 32, margin: '0 auto' }}>
                  <LoadingIndicator style={{ marginLeft: -16 }} />
                </div>
              </div>
            </div>
          )}
          {!this.state.isSending && this.renderStatusDialogContent()}
        </Dialog>
      </>
    );
  }
}

ContactUs.propTypes = {
  language: PropTypes.string,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
  open: PropTypes.bool
};

export default ContactUs;
